module.exports = "9fa83c0842f85c9e4ed399bbf5fd1328.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg3.png
// module id = 70
// module chunks = 0